import { Button } from '@cian/ui-kit';
import { forwardRef } from 'react';

interface IFilterButtonProps {
  children: string;
  beforeIcon?: JSX.Element;
  afterIcon?: JSX.Element;
  onClick: VoidFunction;
}

export const FilterButtonV2 = forwardRef<HTMLButtonElement, IFilterButtonProps>(function FilterButton(
  { children, beforeIcon, afterIcon, onClick },
  ref,
) {
  return (
    <Button
      beforeIcon={beforeIcon}
      afterIcon={afterIcon}
      onClick={onClick}
      theme="fill_white_primary"
      ref={ref}
      size="M"
      tabIndex={0}
    >
      {children}
    </Button>
  );
});
